import React, { useEffect, useState } from "react";
import { Button } from "semantic-ui-react";
import { startJob, startBhHouseJob, sendMsgToRocketChat, updateWorkFlow } from "../../commonApis"
import CancelEntryModal from "./cancelEntry";
import InitiateRFI from "../../components/DMS_App/formSections/header/InitiateRFI";
import { getJobStates } from "../../components/util";
import { useCurrentShipmentType } from "@hooks/useCurrentShipmentType";

const NLDMSStartJobButton = (props) => {
    const {
        shipId: shipmentId,
        isImportShipment,
        declType: declarationEntryType,
        transmissionType,
        version,
        serviceType,
        jobWheels,
        translate,
        lowerEnv,
        kxUser: {
            userBasicInfo: {
                userGuid: brokerUserGuid
            } = {}
        } = {},
        isEmergencyProcedure
    } = props

    // const {kxEngineUserInfo} = useCurrentShipmentType()
    // const isEngineUser = kxEngineUserInfo?.isEngineUser=='true' || false

    const getJobWheel = getJobStates(jobWheels)
    const entryState = getJobWheel('ES_ENTRY_JOB_WHEEL')
    const customState = getJobWheel('NL_CUSTOM_JOB_WHEEL')
    const custumSubState = getJobWheel('NL_DMS_CUSTOM_SUB_PROCES_WHEEL')
    const isEntryOrCustomStateNone = (
        entryState.includes('NONE') || customState.includes('NONE')
    )

    const [type, setType] = useState(null);
    const [eventType, setEventType] = useState(null);
    const [formType, setFormType] = useState(null);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        let _type = 'ENTRY_IN_PROCESS';
        // let _eventType = `TYPE_${declarationEntryType}_NEW`;
        let _eventType = isImportShipment?'DMS_415CRE':'DMS_515CRE'; // type A
        let _formType = `TYPE_${declarationEntryType}`;
        if (entryState === "STATE_ENTRY_ACCEPTED") {
            _type = `TYPE_${declarationEntryType}_NEW`;
            _eventType = 'ENTRY_AMEND_IN_PROCESS'
            _formType = `TYPE_${declarationEntryType}_MOD`;
        }
        setType(_type);
        setEventType(_eventType);
        setFormType(_formType);
    }, [declarationEntryType, transmissionType])

    const startJobClickHandler = async (type, isEngineUser) => {
        try {
            // const extraParams = isEngineUser ? {country:'NL'} : {} 
            await startBhHouseJob(shipmentId, "BH_BROKER_ASSIGNED", brokerUserGuid);
            await startBhHouseJob(shipmentId, "BH_BROKER_IN_PROCESS", brokerUserGuid)
            await sendMsgToRocketChat(shipmentId, 13, brokerUserGuid);
            if (type) {
                startJob(shipmentId, formType, eventType, brokerUserGuid).then(() => {
                    updateWorkFlow(shipmentId, "ENTRY_IN_PROCESS", brokerUserGuid).then(() => {
                        setTimeout(() => {
                            document.getElementById(`card-${shipmentId}`)?.click();
                        }, 0);
                    });
                })
            }
        } catch (err) { console.error(err) }
    }

    return (
        <>
            {isEntryOrCustomStateNone
                && declarationEntryType
                && transmissionType == 'NEW' && (
                    <Button
                        size='mini'
                        key='START_JOB_EU'
                        disabled={false}
                        className='sv todo-button primaryBtn'
                        onClick={(e) => {
                            e.stopPropagation()
                            startJobClickHandler(type)
                        }}
                    >
                        {translate(`START_JOB`).toUpperCase()}
                    </Button>
                )}
            {((entryState.includes('ACCEPTED') || entryState.includes('RELEASED'))
                && transmissionType == 'EXT') && (
                    <Button
                        size='mini'
                        key='START_JOB_EU'
                        disabled={false}
                        className='sv todo-button primaryBtn'
                        onClick={(e) => {
                            e.stopPropagation()
                            updateWorkFlow(shipmentId, "ENTRY_EXT_IN_PROCESS", brokerUserGuid).then(() => {
                                setTimeout(() => {
                                    document.getElementById(`card-${shipmentId}`)?.click();
                                }, 0);
                            });
                        }}
                    >
                        {translate(`START_EXIT_INFO`).toUpperCase()}
                    </Button>
                )}
            {['A', 'B', 'C', 'D', 'X', 'Y'].includes(declarationEntryType) &&
                !['STATE_CANCEL_ACCEPTED', 'STATE_ENTRY_CANCELLED'].includes(entryState) &&
                !(['STATE_DMS_599EXIT', 'STATE_DMS_509CAN'].includes(customState) ||
                    ['STATE_DMS_509CAN', 'STATE_DMS_514SENT'].includes(custumSubState)) &&
                transmissionType === 'CAN' && (
                    <CancelEntryModal
                        key='updateResponseBtn'
                        shipmentId={shipmentId}
                        language='nl'
                        countryCode='NL'
                        serviceType={serviceType}
                        version={version}
                        formType={isImportShipment?'IE414':'IE514'}
                        cancelReason={''}
                        cancelReasonList={null}
                        trigger={
                            <Button
                                size='mini'
                                key='CANCEL_NL'
                                disabled={['STATE_ENTRY_FROZEN']?.includes(entryState)}
                                className='sv todo-button primaryBtn'
                                onClick={() => {
                                    setShowModal(true)
                                }}
                            >
                                {translate(`CANCEL`).toUpperCase()}
                            </Button>
                        }
                        showModal={showModal}
                        setShowModal={setShowModal}
                        lowerEnv={lowerEnv}
                    />
                )}
            {((transmissionType === 'EMERGENCY' && !isEmergencyProcedure)
                && !(
                    entryState?.includes('IN_PROCESS') 
                    || entryState?.includes('ENTRY_READY')
                    || entryState?.includes('RELEASED')
                    )) && (
                    <Button
                        size='mini'
                        key='START_EMERGENCY_PROCEDURE'
                        disabled={false}
                        className='sv todo-button primaryBtn'
                        onClick={(e) => {
                            e.stopPropagation()
                            updateWorkFlow(shipmentId, "ENTRY_IN_PROCESS", brokerUserGuid).then(() => {
                                setTimeout(() => {
                                    document.getElementById(`card-${shipmentId}`)?.click();
                                }, 0);
                            });
                        }}
                    >
                        {translate(`START_EMERGENCY_PROCEDURE`).toUpperCase()}
                    </Button>
                )}
            {transmissionType == 'CRE'
                && !entryState?.includes('RFI') && (
                    <InitiateRFI
                        translate={translate}
                        shipId={shipmentId}
                        brokerGuid={brokerUserGuid}
                    />
                )}
        </>
    )

}

export default NLDMSStartJobButton;



